import background from '../../images/Images/img_background.png';

export const IMAGE = {
  background,
};
